export enum MarketingPreferencesFormField {
  MarketingPreferenceEmail = 'marketingPreferenceEmail',
  MarketingPreferencePost = 'marketingPreferencePost',
  MarketingPreferenceTelephone = 'marketingPreferenceTelephone',
}
